import { call, put, takeLatest } from "redux-saga/effects";
import { customerProductSummaryGetApi } from "../Context/customerProductSummaryApi";
import {
  onGetCustomerProduct,
  onGetCustomerProductError,
  onGetCustomerProductSuccess,
} from "../Store/Slices/customerProductSummarySlice";

function* GetCustomerProduct({ payload }) {
  try {
    const getCustomerProductResponse = yield call(customerProductSummaryGetApi, payload);

    if (getCustomerProductResponse.httpStatusCode === "200") {
      yield put(
        onGetCustomerProductSuccess({
          data: getCustomerProductResponse.response,
          message: getCustomerProductResponse.errorMessage,
          status_code: getCustomerProductResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onGetCustomerProductError({
          data: getCustomerProductResponse.response,
          message: getCustomerProductResponse.errorMessage,
          status_code: getCustomerProductResponse.httpStatusCode,
        })
      );
    }
  } catch (error) {
    const message = error?.response || "Something went wrong";
    yield put(onGetCustomerProductError({ data: {}, message, status_code: 400 }));
  }
}

export default function* customerProductSummarySaga() {
  yield takeLatest(onGetCustomerProduct.type, GetCustomerProduct);
}
